module.exports = __webpack_public_path__ + "img/box5-02.fa335bb0.png";